import PropTypes from 'prop-types';
import React from 'react';
import { Button, Table } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn, BootBootstrapButton } from 'react-bootstrap-table';
import BSTable from './BSTable';
import moment from 'moment';
import { monthNameFormatDate } from '../../../core/date';





class ExpandRow extends React.Component {
  constructor(props) {
    super(props);

  }

  isExpandableRow(row) {
    return true;

  }

  dateDisplay = (row, rowIndex) => {
    return (
      <span> {monthNameFormatDate(row)} </span>
      )
  }

  expandComponent(row) {
    return (
      <BSTable data={row}>
      </BSTable>

    );
  }

  

  render() {
    //debugger
    const options = {
      expandRowBgColor: 'rgb(91, 192, 232)'
    };
    const roomNameFormatter = (cell, row) => {
      switch (cell) {
        case 1:
          return 'Suite'
        case 2:
          return 'King'
        case 3:
          return 'Double'
        case 4:
          return 'Two Beds'
        case 5:
          return 'Junior Suite'
        case 6:
          return '2 Bedroom Suite'
      }
    }

    const numberOfDayFormatter = (cell, row) => {
      const a = moment(row.check_out_date);
      const b = moment(row.check_in_date);
      return a.diff(b, 'days')
    }

    const bidData = [];
    // let bid_details = this.props.bid.bid_bid_details.filter(c => c.bid_details.room_type);
    //let bid_details = this.props.bidbidsDetails.filter(c => c.bid_details.room_type);
    let bid_details = this.props.bidbidsDetails;
    bid_details.map(c => {
      let data = bidData.find(bd => bd.check_in_date == c.bid_details.check_in_date && bd.check_out_date == c.bid_details.check_out_date && bd.room_type == c.bid_details.room_type)
      if (data) {
        data.no_of_Guest++
      } else {
        let insertObj = {
          room_type: c.bid_details.room_type,
          no_of_Guest: 1,
          check_in_date: c.bid_details.check_in_date,
          check_out_date: c.bid_details.check_out_date,
          rate_per_night: c.rate_per_night,
          room_category:c.room_category
        }
        // If room_type is 4 then it's NoHotel room
        if(insertObj.room_type !== 7){
          bidData.push(insertObj)
        }
        // bidData.push(insertObj)
      }
    })
    const hasRoomCategory = bidData.some(data => data.room_category != null && data.room_category !="");

    return (  
      <div>
        {this.props.isLoading == true?(
          <div style={{padding: '0px 0px 30px 280px'}}>
            <i className="fa fa-spinner fa-pulse fa-5x fa-fw" />
            <span className="sr-only">Loading...</span>
          </div>
          ):(
          <BootstrapTable data={bidData}
            options={options}
            striped
          >
            <TableHeaderColumn dataField='id' width='100' hidden>ID</TableHeaderColumn>
            <TableHeaderColumn dataField='room_type' width='100' isKey headerAlign='center' dataAlign='center' dataFormat={roomNameFormatter}>Room Type</TableHeaderColumn>
            {hasRoomCategory&&(
              <TableHeaderColumn dataField="room_category" width="100" headerAlign="center" dataAlign="center">Room Category</TableHeaderColumn>
            )}
            <TableHeaderColumn dataField='no_of_Guest' width='100' headerAlign='center' dataAlign='center'>No of Rooms</TableHeaderColumn>
            <TableHeaderColumn dataField='check_in_date' width='100' headerAlign='center' dataAlign='center' dataFormat={this.dateDisplay}>Check in Date</TableHeaderColumn>
            <TableHeaderColumn dataField='check_out_date' width='100' headerAlign='center' dataAlign='center' dataFormat={this.dateDisplay}>Check out Date</TableHeaderColumn>
            <TableHeaderColumn dataField='no_of_days' width='100' headerAlign='center' dataAlign='center' dataFormat={numberOfDayFormatter}>No of Days</TableHeaderColumn>
            <TableHeaderColumn dataField='rate_per_night' width='100' headerAlign='center' dataAlign='center'>Rate Per Night</TableHeaderColumn>
          </BootstrapTable>
          )}<br></br>
      </div>


    );
  }

}

ExpandRow.propTypes = {
  bid: PropTypes.object.isRequired,
  tourData: PropTypes.object,
  editMember: PropTypes.func,
};

export default ExpandRow;




// WEBPACK FOOTER //
// src/routes/tours/components/ExampleGrid.js